import { Component, inject } from "@angular/core";
import { ROLE_MAP_CONFIG } from "@peca/backoffice/roles.config";

@Component({
  templateUrl: './operations.component.html',
  styleUrls: ['./operations.component.scss'],
  standalone: false,
})
export class OperationsComponent {
  readonly roles = inject(ROLE_MAP_CONFIG);
}
